import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import UIToggle from 'UIComponents/input/UIToggle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { useAchievementStatus, useUpdatePrivacy } from '../../features/achievement';
import UsageTracker from '../../utils/UsageTracker';
import { useTrack } from '../../features/tracks';
export const AwardVisibilityToggle = (_ref) => {
  let {
    onToggle
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["onToggle"]);

  const onChange = useCallback(({
    target: {
      checked
    }
  }) => {
    onToggle(!!checked);
  }, [onToggle]);
  return /*#__PURE__*/_jsx(UIToggle, Object.assign({
    "data-test-id": "award-visibility-toggle",
    onChange: onChange,
    size: "small"
  }, rest));
};
AwardVisibilityToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

const AwardVisibilityToggleContainer = ({
  award,
  disabledTooltip,
  isFetchingAchievements,
  trackId
}) => {
  const {
    track,
    trackLoading
  } = useTrack(parseInt(trackId, 10));
  const {
    updatePrivacy,
    updatePrivacyLoading
  } = useUpdatePrivacy({
    trackId,
    awardCode: award.code,
    shouldBePublic: award.visibility !== 'PUBLIC'
  });
  const {
    isPrivate
  } = useAchievementStatus(trackId);
  const onToggle = useCallback(shouldBePublic => {
    const privacy = shouldBePublic ? 'PUBLIC' : 'PRIVATE';
    updatePrivacy();
    UsageTracker.track('awardInteraction', {
      action: 'toggle-privacy',
      privacy,
      awardName: award && award.awardName,
      awardCode: award && award.code,
      trackName: track && track.name,
      trackId
    });
  }, [award, track, trackId, updatePrivacy]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isPrivate ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledTooltip
    }) : null,
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": updatePrivacyLoading || isFetchingAchievements || trackLoading,
      children: /*#__PURE__*/_jsx(AwardVisibilityToggle, {
        checked: !isPrivate,
        disabled: updatePrivacyLoading || isFetchingAchievements,
        onToggle: onToggle
      })
    })
  });
};

export default AwardVisibilityToggleContainer;